class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      };
  
      this.inputCountry =  this.querySelector('input[name="country_code"]'),
      this.inputLang =  this.querySelector('input[name="language_code"]'),
  
      this.selectedCountryText = this.querySelector('[data-currency-text]'),
      this.selectedLangText = this.querySelector('[data-language-text]'),
  
      this.selectedCountryValue =  null,
      this.selectedLangValue =  null,
  
      document.querySelector('[data-redirection]').addEventListener('click', this.onItemClick.bind(this));  

      this.querySelectorAll('[data-country]').forEach((item) => {
        item.addEventListener('click', () => {
          this.selectedCountryValue = item.dataset.value;
          this.selectedCountryText.innerHTML = item.dataset.text;
          this.querySelector('[data-expandable-wrapper]').classList.toggle('is-open');
        });
      });
  
      this.querySelectorAll('[data-language]').forEach((item) => {
        item.addEventListener('click', () => {
            this.selectedLangValue = item.dataset.value;
            this.selectedLangText.innerHTML = item.dataset.text;
    
            // Trouver et fermer uniquement le wrapper associé
            item.closest('[data-expandable-wrapper]').classList.toggle('is-open');
        });
    });
    
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.inputCountry.value = this.selectedCountryValue;
      this.inputLang.value = this.selectedLangValue;
      if (form) form.submit();
    }
  
  }
  
  customElements.define('localization-form', LocalizationForm);